import React from 'react';
import classNames from 'classnames';
import { DialogKeyboardConfig } from 'lib/hooks/useDialogKeyboard';
import Dialog from '../Dialog';
import { closeModal, showModal } from '../Modal';
import './index.scss';

interface CommonDialogProps {
  title?: string;
  content?: React.ReactNode;
  showCancel?: boolean;
  cancelButtonText?: string;
  cancelCallback?: () => void;
  showConfirm?: boolean;
  confirmButtonText?: string;
  confirmCallback?: () => void;
  tips?: React.ReactNode;
  showCancelButtonTopRightIcon?: boolean;
  showConfirmButtonTopRightIcon?: boolean;
  keyboard?: DialogKeyboardConfig;
}

const CommonDialog = ({
  title,
  content,
  showCancel,
  cancelButtonText,
  cancelCallback,
  showConfirm = true,
  confirmButtonText,
  confirmCallback,
  tips,
  showCancelButtonTopRightIcon = false,
  showConfirmButtonTopRightIcon = false,
  keyboard,
}: CommonDialogProps) => {
  const close = () => {
    closeModal();
    cancelCallback?.();
  };

  const confirm = () => {
    closeModal();
    confirmCallback?.();
  };

  return (
    <Dialog
      title={title}
      keyboard={{
        onEnter: showConfirm ? confirm : false,
        ...keyboard,
      }}
    >
      <div className="common-dialog">
        <div className="common-dialog__content">{content}</div>
        <div className="common-dialog__footer">
          {showCancel ? (
            <div
              className={classNames('common-dialog__footer--btn close', {
                'close-gift-icon': showCancelButtonTopRightIcon,
              })}
              onClick={close}
            >
              {cancelButtonText || '取消'}
            </div>
          ) : null}
          {showConfirm ? (
            <div
              className={classNames('common-dialog__footer--btn confirm', {
                'confirm-gift-icon': showConfirmButtonTopRightIcon,
              })}
              onClick={confirm}
            >
              {confirmButtonText || '我知道了'}
            </div>
          ) : null}
        </div>
        {tips ? <div className="common-dialog__tips">{tips}</div> : null}
      </div>
    </Dialog>
  );
};

export const showCommonDialog = (params) => showModal(<CommonDialog {...params} />);

export default CommonDialog;
